import React from 'react'
import Flag from '../components/Flag'
import classes from './Locale.module.scss'

const Locale = ({ country, language, name, dir, onclick, showFlag = true }) => {
  if (!country || !language || !name) {
    return <></>
  }

  return (
    <a
      className={classes.container}
      onClick={onclick}
      data-testid={`locale-link`}
      data-locale={`${language}_${country}`.toUpperCase()}
      data-root-dir={document.getRootNode().dir}
    >
      {showFlag ? (
        <Flag country={country} size={24} />
      ) : (
        <div className={classes.emptyFlag} />
      )}
      <div className={classes.countryName} dir={dir}>
        {name}
      </div>
    </a>
  )
}

export default Locale
